const extractServerAction = data => {
  const actions = data === null || data === void 0 ? void 0 : data['atlassian:serverAction'];
  if (!actions) {
    return [];
  }
  if (actions && !Array.isArray(actions)) {
    return [actions];
  }
  return actions;
};
export default extractServerAction;